if (!customElements.get('bundle-save')) {
  customElements.define('bundle-save', class BundleSave extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-bundle-product]').textContent);
      this.offers = [...this.querySelectorAll('[data-bundle-offer]')];
      this.offers.forEach((offer) => offer.querySelector('input').addEventListener('change', () => this.selectOffer(offer)));
      document.addEventListener('change', (event) => {
        if (event.target.closest(`#${CSS.escape(this.dataset.productFormId)}`)?.matches('form')) this.syncPrimaryVariant();
      });
      this.updatePrices();
      this.selectOffer(this.querySelector('.is-selected') || this.offers[0]);
    }

    get selectedInput() { return this.querySelector('input[type="radio"]:checked'); }
    get hasBundleSelection() { return Boolean(this.selectedInput); }

    selectOffer(offer) {
      this.offers.forEach((item) => item.classList.toggle('is-selected', item === offer));
      offer.querySelector('input').checked = true;
      this.renderVariantSelectors(offer, Number(offer.querySelector('input').value));
    }

    primaryVariantId() {
      return String(document.getElementById(this.dataset.productFormId)?.querySelector('[name="id"]')?.value || this.data.variants[0].id);
    }

    syncPrimaryVariant() {
      const first = this.querySelector('[data-bundle-item]');
      if (first) this.setItemVariant(first, this.primaryVariantId());
      this.updatePrices();
    }

    renderVariantSelectors(offer, quantity) {
      this.querySelectorAll('[data-bundle-variants]').forEach((host) => {
        if (host !== offer.querySelector('[data-bundle-variants]')) host.replaceChildren();
      });
      const variantHost = offer.querySelector('[data-bundle-variants]');
      if (!variantHost) return;
      variantHost.replaceChildren();
      if (quantity < 1) return;
      const heading = document.createElement('span');
      heading.className = 'bundle-save__variant-heading';
      heading.textContent = (this.data.options || []).map((name) => {
        const normalized = name.toLowerCase();
        if (normalized.includes('color') || normalized.includes('colour') || normalized === 'cor') return 'Color';
        if (normalized.includes('size') || normalized.includes('tamanho')) return 'Size';
        return name;
      }).join(', ');
      variantHost.append(heading);
      for (let index = 0; index < quantity; index += 1) {
        const row = document.createElement('div');
        row.className = 'bundle-save__variant-row';
        row.dataset.bundleItem = '';
        row.innerHTML = `<img data-variant-image alt=""><div class="bundle-save__option-controls"></div><input type="hidden" data-bundle-variant>`;
        const controls = row.querySelector('.bundle-save__option-controls');
        (this.data.options || []).forEach((name, optionIndex) => {
          const wrapper = document.createElement('label');
          wrapper.innerHTML = `<span class="visually-hidden">${name}</span><select data-option-index="${optionIndex}" aria-label="Item ${index + 1} ${name}"></select>`;
          const select = wrapper.querySelector('select');
          [...new Set(this.data.variants.map((variant) => variant.options[optionIndex]))].forEach((value) => select.add(new Option(value, value)));
          select.addEventListener('click', (event) => event.stopPropagation());
          select.addEventListener('change', () => this.resolveItemVariant(row));
          controls.append(wrapper);
        });
        this.setItemVariant(row, this.primaryVariantId());
        variantHost.append(row);
      }
    }

    setItemVariant(row, variantId) {
      const variant = this.data.variants.find((item) => String(item.id) === String(variantId)) || this.data.variants[0];
      row.querySelectorAll('[data-option-index]').forEach((select) => { select.value = variant.options[Number(select.dataset.optionIndex)]; });
      this.applyItemVariant(row, variant);
    }

    resolveItemVariant(row) {
      const values = [...row.querySelectorAll('[data-option-index]')].map((select) => select.value);
      const variant = this.data.variants.find((item) => item.options.every((value, index) => value === values[index]));
      if (variant) this.applyItemVariant(row, variant);
    }

    applyItemVariant(row, variant) {
      row.querySelector('[data-bundle-variant]').value = variant.id;
      const image = row.querySelector('[data-variant-image]');
      image.src = variant.featured_image?.src || this.data.featuredImage || '';
      image.alt = variant.title || '';
      image.hidden = !image.src;
      row.classList.toggle('is-unavailable', !variant.available);
      row.querySelectorAll('select').forEach((select) => select.setCustomValidity(variant.available ? '' : 'This combination is sold out'));
    }

    updatePrices() {
      const primary = this.data.variants.find((variant) => String(variant.id) === this.primaryVariantId()) || this.data.variants[0];
      this.querySelectorAll('[data-offer-price]').forEach((node) => {
        const quantity = Number(node.dataset.quantity);
        const discount = Number(node.dataset.discount);
        node.textContent = this.formatMoney(Math.round(primary.price * quantity * (100 - discount) / 100));
      });
      this.querySelectorAll('[data-offer-compare]').forEach((node) => {
        const quantity = Number(node.dataset.quantity);
        const discount = Number(node.dataset.discount);
        const compareEach = primary.compare_at_price > primary.price ? primary.compare_at_price : primary.price;
        const shouldShow = discount > 0 || compareEach > primary.price;
        node.textContent = shouldShow ? this.formatMoney(compareEach * quantity) : '';
        node.hidden = !shouldShow;
      });
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, this.data.moneyFormat);
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
    }

    async addSelectedBundle(productForm) {
      const error = this.querySelector('[data-bundle-error]');
      error.hidden = true;
      const quantity = Number(this.selectedInput.value);
      const discount = Number(this.selectedInput.dataset.discount);
      const selectors = [...this.querySelectorAll('[data-bundle-variant]')];
      const ids = selectors.length
        ? selectors.map((select) => Number(select.value))
        : Array.from({ length: quantity }, () => Number(this.primaryVariantId()));
      const group = `${this.dataset.productId}-${Date.now()}-${crypto.getRandomValues(new Uint32Array(1))[0]}`;
      const items = ids.map((id) => ({ id, quantity: 1, properties: {
        _offer_type: quantity === 1 ? 'single' : 'bundle', _source_product: this.dataset.productId,
        _bundle_group: group, _bundle_quantity: String(quantity), _discount_percent: String(discount)
      }}));
      const button = productForm.querySelector('[type="submit"]');
      button?.setAttribute('aria-disabled', 'true');
      button?.classList.add('loading');
      try {
        const cart = document.querySelector('cart-drawer');
        const cartState = await this.fetchCartState();
        const cleanCartState = await this.clearPreviousOffer(cartState);
        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
          body.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }
        const response = await fetch(routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add bundle');
        let finalResult = result;
        if (this.selectedInput.dataset.discountCode) finalResult = await this.applyBundleDiscount(this.selectedInput.dataset.discountCode, cleanCartState, cart);
        if (cart && !this.renderCartSections(cart, finalResult)) await this.refreshCartDrawer(cart);
      } catch (exception) {
        error.textContent = exception.message;
        error.hidden = false;
      } finally {
        button?.removeAttribute('aria-disabled');
        button?.classList.remove('loading');
      }
    }

    async fetchCartState() {
      const cartResponse = await fetch(`${routes.cart_url}.js`, { cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('Could not read the current cart');
      return cartResponse.json();
    }

    async clearPreviousOffer(cartState) {
      const updates = {};
      cartState.items.forEach((item) => {
        if (String(item.properties?._source_product || '') === String(this.dataset.productId)) updates[item.key] = 0;
      });
      const managedCodes = [
        cartState.attributes?._bundle_discount_code,
        ...(cartState.attributes?._bump_discount_codes || '').split(',')
      ].filter(Boolean);
      const customerCodes = (cartState.discount_codes || [])
        .map((discount) => discount.code).filter((code) => code && !managedCodes.includes(code));
      if (!Object.keys(updates).length && !managedCodes.length) return cartState;
      const response = await fetch(routes.cart_update_url, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, discount: customerCodes.join(','), attributes: {
          _bundle_discount_code: '', _bump_discount_codes: ''
        } })
      });
      if (!response.ok) throw new Error('Could not replace the previous offer');
      return response.json();
    }

    async applyBundleDiscount(code, cartState, cart) {
      if (!code) throw new Error('Bundle discount code is not configured');
      const previousManagedCode = cartState.attributes?._bundle_discount_code || '';
      const currentCodes = (cartState.discount_codes || []).map((discount) => discount.code).filter(Boolean);
      const codes = [...new Set([...currentCodes.filter((current) => current !== previousManagedCode), code])];
      const body = { discount: codes.join(','), attributes: { _bundle_discount_code: code } };
      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
        body.sections_url = window.location.pathname;
      }
      const response = await fetch(routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error('Could not apply bundle discount');
      const updatedCart = await response.json();
      const applied = (updatedCart.discount_codes || []).some(
        (discount) => discount.code?.toLowerCase() === code.toLowerCase() && discount.applicable !== false
      );
      if (!applied) throw new Error(`Discount code ${code} is not eligible for this bundle`);
      return updatedCart;
    }

    renderCartSections(cart, result) {
      const sectionHtml = result?.sections?.['cart-drawer'];
      if (!sectionHtml) return false;
      const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const source = html.querySelector('#CartDrawer');
      const target = cart.querySelector('#CartDrawer');
      if (!source || !target) return false;
      target.innerHTML = source.innerHTML;
      cart.classList.remove('is-empty');
      cart.querySelector('#CartDrawer-Overlay')?.addEventListener('click', cart.close.bind(cart));
      cart.open();
      return true;
    }

    async refreshCartDrawer(cart) {
      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, { cache: 'no-store' });
      if (!response.ok) throw new Error('Could not refresh cart drawer');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.querySelector('#CartDrawer');
      const target = cart.querySelector('#CartDrawer');
      if (!source || !target) throw new Error('Cart drawer markup was not found');
      target.innerHTML = source.innerHTML;
      cart.classList.remove('is-empty');
      cart.querySelector('#CartDrawer-Overlay')?.addEventListener('click', cart.close.bind(cart));
      cart.open();
    }
  });
}
